import notebookImage from '../../assets/images/setupProfileNotebook.png'
import notebookImage2x from '../../assets/images/setupProfileNotebook@2x.png'

interface NotebookIconProps {
  size?: number
  className?: string
}

export const NotebookIcon = ({ size = 100, className = '' }: NotebookIconProps) => (
  <img
    src={notebookImage}
    srcSet={`${notebookImage} 1x, ${notebookImage2x} 2x`}
    alt="Notebook"
    width={size}
    height={size}
    className={className}
  />
)
